import {
  Card,
  Stack,
  Container,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SettingsRenderer from ".";
import { getUserPermissions } from "src/utils/permissionsUtils";

const { isViewer } = getUserPermissions();

const getSettingsJson = (settingsType, settings) => {
  if (settings === null) return "";
  const settingsJson = settings.find(
    (item) => item.settingsType === settingsType
  );
  return settingsJson ? settingsJson.settings : "";
};

const safeParse = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};
const formatNameWithSpaces = (str) =>
  str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (match) => match.toUpperCase());
const settingsGridTemplate = [4, 2, 3, 3, 5, 3, 4, 8, 4, 4, 4];

export default function AppSettingsTable({
  rows,
  settings,
  handleOpenUpdateDialog,
  handleToggleSeasonEndAlert,
  isSeasonEndAlertUpdating,
}) {
  if (!rows || rows.length === 0) {
    console.log("No rows available");
    return null;
  }

  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4" gutterBottom>
          App Settings
        </Typography>
      </Stack>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {rows.map((row) => (
          <Grid item xs={settingsGridTemplate[row.value]} key={row.value}>
            <Card
              sx={{
                position: "relative",
                height: "180px",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                boxShadow: 3,
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s ease-in-out",
              }}
            >
              {!isViewer && row.value !== 9 && (
                <IconButton
                  onClick={() => {
                    handleOpenUpdateDialog(row.value);
                  }}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    "&:hover": {
                      backgroundColor: "primary.main",
                      color: "white",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                  size="small"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              )}

              <Typography
                variant="subtitle1"
                sx={{
                  p: 2,
                  pb: 1,
                  textAlign: "center",
                  fontWeight: 600,
                  color: "primary.main",
                  fontSize: "0.9rem",
                }}
              >
                {formatNameWithSpaces(rows[row.value].name)}
              </Typography>

              <SettingsRenderer
                settingsType={row.value}
                rawData={safeParse(getSettingsJson(row.value, settings))}
                handleToggleSeasonEndAlert={handleToggleSeasonEndAlert}
                isSeasonEndAlertUpdating={isSeasonEndAlertUpdating}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
